// extracted by mini-css-extract-plugin
export default {"cls1":"EmailLoginPage-cls1_by2","cls2":"EmailLoginPage-cls2__EW EmailLoginPage-cls1_by2"};